import axios from 'axios';
const api = axios.create({
  /* baseURL: process.env.REACT_APP_API_URL, */
baseURL: 'https://flt-api.foundrylawgroup.com/api/',
//  baseURL: 'https://flt-api-staging.foundrylawgroup.com/api/',

// baseURL: 'https://localhost:44384/api/',
//baseURL: "http://projects.ginilytics.org:4006/api/", 
  //baseURL: 'http://192.168.10.108:4006/api/',
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use(
  (config) => {
    const accessToken = localStorage.getItem('accessToken');
    if (accessToken) {
      config.headers.Authorization = `Bearer ${accessToken}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response.status === 401) {
      localStorage.removeItem('accessToken')
      window.location.href='/'
    }
    return Promise.reject(error);
  }
);
export default api;